var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorCircleCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "warning-circle--warning-alert-frame-exclamation-caution-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.99958 19.2863C15.128 19.2863 19.2853 15.129 19.2853 10.0006C19.2853 4.8722 15.128 0.714844 9.99958 0.714844C4.87122 0.714844 0.713867 4.8722 0.713867 10.0006C0.713867 15.129 4.87122 19.2863 9.99958 19.2863Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.99958 19.0714C15.128 19.0714 19.2853 14.9141 19.2853 9.78571C19.2853 4.65736 15.128 0.5 9.99958 0.5C4.87122 0.5 0.713867 4.65736 0.713867 9.78571C0.713867 14.9141 4.87122 19.0714 9.99958 19.0714Z",
    stroke: "#B71C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 2609550"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.99951 7L12.9995 13.4286",
    stroke: "#B71C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3_2",
    d: "M12.9995 7L6.99951 13.4286",
    stroke: "#B71C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorCircleCross);
export default __webpack_public_path__ + "static/media/error-circle-cross.9ac177a9539acf26500f71e8859ed47c.svg";
export { ForwardRef as ReactComponent };